import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import debounce from 'transmute/debounce';
import emptyFunction from 'react-utils/emptyFunction';
const COMPACT_BREAKPOINT = 632;
export default function withWindowListeners(WrappedComponent, compactBreakpoint = COMPACT_BREAKPOINT) {
  var _temp;

  return _temp = class extends Component {
    constructor(props) {
      super(props);

      this.setCompactState = compact => {
        this.setState({
          compact
        });
      };

      this.handleResize = e => {
        const {
          forceMobile
        } = this.props;
        const {
          compact
        } = this.state;
        const target = e.target;

        if (forceMobile) {
          if (!compact) {
            this.setCompactState(true);
          }
        } else {
          if (target.innerWidth < compactBreakpoint && !compact) {
            this.setCompactState(true);
          } else if (target.innerWidth >= compactBreakpoint && compact) {
            this.setCompactState(false);
          }
        }
      };

      this.resizeHandler = emptyFunction;

      const _compact = props.forceMobile || window.innerWidth < compactBreakpoint;

      this.state = {
        compact: _compact
      };
    }

    componentDidMount() {
      const {
        embedded
      } = this.props;
      this.resizeHandler = embedded ? this.handleResize : debounce(100, this.handleResize);
      window.addEventListener('resize', this.resizeHandler);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.resizeHandler);
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        compact: this.state.compact
      }));
    }

  }, _temp;
}